import { ColumnDef } from '@tanstack/react-table';
import { formatPhone } from 'src/utils/format-phone';
import { RouterOutput } from 'src/trpc';
import { StatusDisplay } from 'components/StatusDisplay';
import { OrderStatus } from '@libs/schemas/src/order';
import { format } from 'date-fns';
import { PickupActualBadge } from 'src/components/PickupActualBadge';

export const OrderColumns: ColumnDef<
  RouterOutput['admin']['order']['adminListOrders']['orders'][0]
>[] = [
  {
    accessorKey: 'friendlyId',
    header: 'Order ID',
  },
  {
    header: 'Customer',
    accessorFn: (row) => `${row.user?.name?.first || ''} ${row.user?.name?.last || ''}`,
  },
  {
    header: 'Email',
    accessorKey: 'user.email',
  },
  {
    header: 'Phone Number',
    accessorFn: (row) => formatPhone(row.user?.phone || ''),
  },
  {
    header: 'Drop-off Date',
    accessorFn: (row) => {
      return row.dropOffWindow?.day ? `${format(row.dropOffWindow?.day, 'MM/dd/yyyy')}` : 'N/A';
    },
  },
  {
    header: 'Status',
    accessorKey: 'status',
    cell: (row) => {
      const status = row.getValue() as OrderStatus;

      return (
        <div className="flex items-center gap-2">
          <StatusDisplay status={status} />
          {row.row.original.pickupWindow?.isActualPickupDate && <PickupActualBadge />}
        </div>
      );
    },
  },
];
